import { jsx, jsxs } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { useExpandedFdocContentContext } from './ExpandedFdocContentContext.js';
import { useResourceDataContext } from '../context/resourceDataContext.js';
import { MediaContent } from './MediaContent.js';
import { ResourceAudioPlayer } from '../ExpandedResource/Content/Audio/ResourceAudioPlayer.js';
import { ResourceVideoPlayer } from '../ExpandedResource/Content/Video/ResourceVideoPlayer.js';
import { ExpandedFdocElements } from './ExpandedFdocElements.js';
import { isResourceDetailDocument, isResourceDetailImage, isResourceDetailVideo, isResourceDetailAudio } from '../../../resources/utils/resourceDetailGuards.js';
import FileDisplay from '../../../resources/components/FileDisplay.js';
import { ButtonIconDownload } from '@fabric-app/ui/components/button/ButtonIconDownload';
import { DocumentContent } from './DocumentContent.js';

function StoredFileContent({ imageRef, isFullscreenEnabled, tinyPagesIsVisible, disableGestures }) {
  const { topHeaderControlsRef } = useExpandedFdocContentContext();
  const { resource, handleDownload } = useResourceDataContext();
  if (!resource) {
    return null;
  }
  const downloadButton = topHeaderControlsRef && handleDownload ? /* @__PURE__ */ createPortal(/* @__PURE__ */ jsx(ButtonIconDownload, {
    onClick: handleDownload
  }), topHeaderControlsRef) : null;
  if (isResourceDetailDocument(resource)) {
    return /* @__PURE__ */ jsx(DocumentContent, {
      isFullscreenEnabled,
      tinyPagesIsVisible,
      downloadButton
    });
  }
  if (isResourceDetailImage(resource)) {
    return /* @__PURE__ */ jsx(MediaContent, {
      imageRef,
      disableGestures
    });
  }
  if (isResourceDetailVideo(resource)) {
    return /* @__PURE__ */ jsx(ResourceVideoPlayer, {});
  }
  if (isResourceDetailAudio(resource)) {
    return /* @__PURE__ */ jsx(ResourceAudioPlayer, {});
  }
  return /* @__PURE__ */ jsxs(ExpandedFdocElements.StoredFile, {
    children: [
      downloadButton,
      /* @__PURE__ */ jsx(FileDisplay, {
        fileExtension: resource.extension,
        fileName: resource.name || "untitled",
        onClick: handleDownload
      })
    ]
  });
}

export { StoredFileContent };
//# sourceMappingURL=StoredFileContent.js.map
